import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { getParameterByName } from 'src/modules/_global/js/_utils'
import { format, parseISO } from 'date-fns';

import wowChallenge100 from 'src/files/wow100-optimised.png?inline';
import wowChallenge50 from 'src/files/wow50-optimised.png?inline';
import museoSansFont from 'src/files/MuseoSans-300.ttf';

pdfMake.fonts = {
    museoSans: {
        normal: museoSansFont
    }
}

export function generateWowCertificate(userDataObj, currentExp, milestoneNumber, ref) {
    const { firstName, lastName } = userDataObj;
    // console.log(userDataObj, currentExp, milestoneNumber);
    const printAward = milestoneNumber != 0 ? {
        text: [firstName, ' ', lastName],
        margin: [0, 400],
        alignment: 'center',
        fontSize: 30,
        color: '#0f2d52',
        pageBreak: 'after'
    } : null;

    const printAllExperience = currentExp.map((experience) => {
        return [{
                text: experience.expName,
                style: 'html-heading'
            },
            {
                text: experience.expType[0]
            },
            {
                text: 'Date: ' + format(parseISO(experience.startDate), 'dd/MM/yyyy') + ' - ' + format(parseISO(experience.endDate), 'dd/MM/yyyy')
            },
            {
                text: 'Total time: ' + (Math.round((experience.hoursCompleted / 60) * 10) / 10) + 'hrs'
            },
            {
                text: 'My reflections'
            },
            {
                text: experience.lessonsLearned,
                style: 'html-last'
            }

        ]
    });
    const docDefinition = {
        background: function(currentPage) {
            if (milestoneNumber != 0 && currentPage === 1) {
                return [{
                    // image: wowChallenge100,
                    image: milestoneNumber >= 100 ? wowChallenge100 : wowChallenge50,
                    width: 600
                }]
            }
        },
        content: [
            printAward,
            ...printAllExperience
            // {
            //     ul: [
            //         'Item 1',
            //         'Item 2',
            //         'Item 3',
            //         { text: 'Item 4' },
            //     ]
            // }
        ],
        defaultStyle: {
            font: 'museoSans'
        },
        styles: {
            'html-heading': {
                fontSize: 13,
                margin: [0, 10, 0, 5]
            },
            'html-p': {
                fontSize: 11,
                margin: [0, 0, 0, 5]
            },
            'html-a': {
                color: '#1a51c1'
            },
            'html-blockquote': {
                margin: [18, 0, 0, 5]
            },
            'html-ul': {
                margin: [18, 5, 0, 10]
            },
            'html-ol': {
                margin: [18, 5, 0, 10]
            },
            'html-li': {
                margin: [0, 0, 0, 0]
            },
            'html-last': {
                margin: [0, 0, 0, 10]
            }
        },
    }

    function outputPdf(dd) {
        // add query string param '?iframepdf' to test pdf
        const pdfDocGenerator = pdfMake.createPdf(dd);
        if (getParameterByName("iframepdf") !== null) {
            pdfDocGenerator.getDataUrl((dataUrl) => {
                const injectedDiv = document.createElement("div")
                injectedDiv.setAttribute('id', 'loadpdf')
                ref.current.appendChild(injectedDiv)
                const targetElement = document.querySelector('#loadpdf');
                const iframe = document.createElement('iframe');
                iframe.src = dataUrl;
                targetElement.appendChild(iframe);
            });
        } else {
            const pdfName = milestoneNumber != 0 ? `WOW Challenge - ${firstName} ${lastName}.pdf` : `Worklog - ${firstName} ${lastName}.pdf`;
            pdfDocGenerator.download(pdfName);
        }
    }
    outputPdf(docDefinition)
}